//src/app/features/auth/signUp/service.ts
import Auth from '@aws-amplify/auth';
import { AllFormData } from '.';

export async function signUp(form: AllFormData) {
  const {
    signupEmail,
    signupPassword,
    firstName,
    lastName,
    language_id,
    phoneNumber,
    address = 'N/A',
    zipcode = '00000',
    city = 'N/A',
    time_zone_id,
    hearAboutUs,
  } = form;
  const signUpResult = await Auth.signUp({
    username: (signupEmail || phoneNumber).toLowerCase(),
    password: signupPassword,
    attributes: {
      email: signupEmail?.toLowerCase(),
      given_name: firstName,
      family_name: lastName,
      zoneinfo: time_zone_id?.toString(),
      locale: language_id?.toString(),
      address: address,
      'custom:hear_about_us': hearAboutUs,
      'custom:zipcode': zipcode,
      'custom:city': city, // New Field'
    },
  });
  return signUpResult;
}
